import React from 'react';

import VrmChecker, { VrmCheckerProps } from '../VrmChecker/VrmChecker';
import VrmUlezChecker from '../VrmUlezChecker/VrmUlezChecker';

export const VrmCheckerFooter = (
  {
    useUlezVrmChecker = false,
    ...props
  }: Partial<VrmCheckerProps> & { useUlezVrmChecker?: boolean },
) => (useUlezVrmChecker ? <VrmUlezChecker hideErrors inFooter /> : <VrmChecker {...props} />);
